// src/components/bot/botApi.js
import axios from 'axios';

const BASE_URL = (() => {
  const raw = process.env.REACT_APP_API_URL || 'https://api.iotroncs.com/api/v1';
  const u = raw.trim().replace(/\/+$/, '');
  return /\/api\/v1$/i.test(u) ? u : `${u}/api/v1`;
})();

// ── Axios instance ─────────────────────────────────────────────
const botAxios = axios.create({ baseURL: BASE_URL, timeout: 30_000, withCredentials: true });

botAxios.interceptors.request.use(async (config) => {
  // Fetch token directly from localStorage
  const token = localStorage.getItem('access_token');
  if (token) {
    // Some apps store tokens as raw strings, some as JSON strings
    let finalToken = token;
    try {
      if (token.startsWith('"') && token.endsWith('"')) {
        finalToken = JSON.parse(token);
      }
    } catch(e) {}
    config.headers.Authorization = `Bearer ${finalToken}`;
  }
  return config;
});

// ── Public helper: safe fetch → { ok, data, status, message } ──
export async function botFetch(url) {
  try {
    const { data } = await botAxios.get(url);
    return { ok: true, data };
  } catch (e) {
    const status  = e.response?.status;
    const message = e.response?.data?.error || e.message || 'Request failed';
    if (status === 403) return { ok: false, status, message: `Access denied (${message})` };
    if (status === 401) return { ok: false, status, message: 'Authentication failed — check user login session' };
    return { ok: false, status, message };
  }
}

export default botAxios;
